module.exports = __webpack_public_path__ + "img/multi_image01.887df23e.png";